import {
  ILaboratoryCollection,
  ILaboratoryCredentialCollection,
  ILaboratoryPayload,
} from 'models/laboratory';
import { axiosEndPoint } from 'utils/axios';

const path = '/laboratory';

export const getLaboratoriesList = async () => {
  const response = await axiosEndPoint.get<ILaboratoryCollection[]>(`${path}`);
  return response.data;
};

export const getLaboratoryById = async (id: string) => {
  const response = await axiosEndPoint.get<ILaboratoryCollection[]>(
    `${path}/${id}`,
  );
  return response.data;
};

export const getLaboratoryByCnpj = async (cnpj: string) => {
  const response = await axiosEndPoint.get<ILaboratoryCollection[]>(
    `${path}/cnpj`,
    {
      params: { cnpj: cnpj },
    },
  );
  return response.data;
};

export const getLaboratoryByCode = async (code: string) => {
  const response = await axiosEndPoint.get<ILaboratoryCollection[]>(
    `${path}/code`,
    {
      params: { code: code },
    },
  );
  return response.data;
};

export const deleteLaboratoryById = async (id: string) => {
  const response = await axiosEndPoint.delete<ILaboratoryCollection[]>(
    `${path}/${id}`,
  );
  return response.data;
};

export const postLaboratory = async (payload: ILaboratoryPayload) => {
  const response = await axiosEndPoint.post<ILaboratoryCollection[]>(
    `${path}`,
    payload,
  );
  return response.data;
};

export const patchLaboratory = async (
  id: string,
  payload: ILaboratoryPayload,
) => {
  const response = await axiosEndPoint.patch<ILaboratoryCollection[]>(
    `${path}/${id}`,
    payload,
  );
  return response.data;
};

export const postLaboratoryBulkRemove = async (payload: string[]) => {
  const response = await axiosEndPoint.post<ILaboratoryCollection[]>(
    `${path}/bulk`,
    payload,
  );
  return response.data;
};

export const getLaboratoryCredentialAndType = async (
  laboratoryId: string,
  type: string,
) => {
  const response = await axiosEndPoint.get<ILaboratoryCredentialCollection>(
    `${path}/${laboratoryId}/credentials/by-type/${type}`,
  );
  return response.data;
};

export const postShiftLogin = async (
  laboratoryId?: string,
): Promise<{ iframeUrl: string }> => {
  const response = await axiosEndPoint.post<{ iframeUrl: string }>(
    '/api/shift/login',
    laboratoryId ? { laboratoryId } : {},
    { withCredentials: true },
  );
  return response.data;
};
